import store from '../configureStore';
import { apiPost } from './apiUtil';

export const sendEmails = (emailList: string | string[], senderName: string, link: string) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();
  const sendTo = Array.isArray(emailList) && emailList.length > 0 ? emailList.join(',') : emailList;
  return apiPost(`/email/send?gid=${currentUserGroup}`, {
    headers: header ? { Authorization: header } : undefined,
    body: `to=${sendTo}&name=${senderName}&link=${link}`,
  });
};

export const sendEmailsWithMessage = (emailList: string | string[], senderName: string, link: string, message: string) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();
  const sendTo = Array.isArray(emailList) && emailList.length > 0 ? emailList.join(',') : emailList;
  return apiPost(`/email/send?gid=${currentUserGroup}`, {
    headers: header ? { Authorization: header } : undefined,
    body: `to=${sendTo}&name=${senderName}&link=${link}&message=${message}`,
  });
};
